var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31.599,
    height: 31.59,
    viewBox: "0 0 31.599 31.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_292",
    "data-name": "Rectangle 292",
    width: 31.599,
    height: 31.59,
    fill: "#015c7e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_377",
    "data-name": "Groupe 377",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_344",
    "data-name": "Groupe 344",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2831",
    "data-name": "Trac\\xE9 2831",
    d: "M0,27.174a1.338,1.338,0,0,1,.9-.851q4.695-1.865,9.381-3.752a1.447,1.447,0,0,1,1.158,0c1.864.759,3.735,1.5,5.6,2.25a.993.993,0,1,1-.723,1.836c-1.384-.549-2.765-1.1-4.147-1.658-.093-.037-.188-.07-.321-.119v.357q0,7.468-.007,14.935a.434.434,0,0,0,.338.48c2.416.954,4.827,1.923,7.238,2.888.094.037.189.073.331.128v-.381q0-4.891,0-9.782a2.251,2.251,0,0,1,.018-.4.984.984,0,0,1,1.946.073,3.225,3.225,0,0,1,.009.37q0,4.876,0,9.751v.371c.462-.182.889-.349,1.315-.519,2.1-.839,4.192-1.683,6.294-2.512a.4.4,0,0,0,.3-.447c-.008-3.569,0-7.138-.008-10.707a1.032,1.032,0,0,1,.573-1.039.98.98,0,0,1,1.4.792,3.1,3.1,0,0,1,.008.339q0,5.662,0,11.324a1.117,1.117,0,0,1-.878,1.3Q26,44.092,21.285,45.984a1.384,1.384,0,0,1-1.1,0c-3-1.209-6-2.406-9-3.615a.788.788,0,0,0-.642,0Q6.1,44.158,1.647,45.932C.8,46.27.462,46.156,0,45.38ZM1.975,43.66c.123-.045.217-.078.31-.115,2.431-.971,4.86-1.947,7.295-2.908a.4.4,0,0,0,.3-.444Q9.869,32.7,9.874,25.2c0-.1-.009-.2-.015-.32-.123.046-.217.081-.31.118-2.421.968-4.84,1.941-7.265,2.9a.417.417,0,0,0-.315.464q.012,7.482.006,14.963Z",
    transform: "translate(0 -14.522)",
    fill: "#015c7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2832",
    "data-name": "Trac\\xE9 2832",
    d: "M57.891,0c.634.162,1.287.271,1.9.494a6.879,6.879,0,0,1,4.39,6.41,7.4,7.4,0,0,1-.947,3.193,34,34,0,0,1-4.461,6.452c-.244.292-.485.587-.743.867a.964.964,0,0,1-1.512,0,36.378,36.378,0,0,1-5.19-7.291,7.827,7.827,0,0,1-.916-2.729,6.371,6.371,0,0,1,1.2-4.422A6.755,6.755,0,0,1,56.452.056,1.522,1.522,0,0,0,56.657,0ZM57.27,15.291A32.667,32.667,0,0,0,61.7,8.742,4.209,4.209,0,0,0,62.2,6.732a4.939,4.939,0,0,0-7.7-3.9,4.671,4.671,0,0,0-1.591,6.081A33.651,33.651,0,0,0,55.8,13.42c.469.621.962,1.224,1.472,1.871",
    transform: "translate(-32.587 0)",
    fill: "#015c7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2833",
    "data-name": "Trac\\xE9 2833",
    d: "M64.476,17.111a2.96,2.96,0,1,1,2.971-2.957,2.99,2.99,0,0,1-2.971,2.957m1-2.974a.985.985,0,1,0-.965,1,.992.992,0,0,0,.965-1",
    transform: "translate(-39.8 -7.239)",
    fill: "#015c7e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/map-icon.8e41992588655e48dbc4e3569587ba94.svg";
export { ForwardRef as ReactComponent };